module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"height":"키","weight":"몸무게","purchased_size":"구매 사이즈"}}')
  delete Component.options._Ctor
}
